function ButtonArticle({ link = "#", caption = "not set", star = false, link2 = "#" }) {
  console.log(link);
  return (
    <div className="row p-2">
      <div className="d-flex px-0">
        <button
          className="btn text-light btn-success flex-grow-me-1 me-2 w-100"
          onClick={() => (window.location.href = link)}
        >
          {star && <span class="me-2">🌟</span>}
          {caption}
        </button>
        {/* </div> */}
        {/* <div className='col-1'> */}
        <button className="btn text-light btn-success me-2" onClick={() => (window.location.href = link2)}>
          (Article)
        </button>
        {/* </div> */}
        {/* <div className='col-1'> */}
      </div>
    </div>
  );
}

export default ButtonArticle;
